module.exports = __webpack_public_path__ + "a02042db35a4dcc72ec4934e36739be7.png";